import axios from "axios";
import { Dispatch } from "redux";
import { Vehicle } from "../types";
import { Action } from "./actions";
import { VehicleActions } from "./action_types";

export const create_vehicle = (vehicle: Vehicle) => {
  return (dispatch: Dispatch<Action>) => {

    dispatch({
      type: VehicleActions.CREATE_VEHICLE,
      payload: vehicle
    })
  }
}

export const update_vehicle = (vehicle: Vehicle) => {
  return async (dispatch: Dispatch<Action>) => {
    await axios.put(`/api/vehicles/${vehicle?.id}/`, vehicle)

    dispatch({
      type: VehicleActions.UPDATE_VEHICLE,
      payload: vehicle
    })
  }
}

export const reprocessVehicle = async (pk: string, sk: string, target: string) => {
  try {
    const url = `${process.env.REACT_APP_UMS_API_BASE_URL}/asset/reprocess`;
    const headers = {
      Authorization: 'bwenvdev'
    };

    const response = await axios.post(url, { pk, sk, target }, { headers });
  } catch (error: any) {
    console.log(error)
    if (error.status === 423) {
      const assetId = pk.replace("asset#",'').split("-")[0]
      alert(`Vehicle ${assetId} is currently locked. Try again later.`);
    } else {
      console.error("Error reprocessing vehicle", error);
      alert("Error reprocessing vehicle. Please check the logs.");
    }
  }
};
